import { MessageTimestampProps, useMessageContext } from 'stream-chat-react';
import { isThisWeek, isToday, isYesterday } from 'date-fns';
import { formatDate } from '@/utils/helpers';

export const CustomMessageTimestamp = (props: MessageTimestampProps) => {
  const context = useMessageContext();
  const message = props?.message || context?.message;
  const date = message?.created_at ? new Date(message.created_at) : null;
  if (!date) return null;

  let display = '';

  if (isToday(date)) {
    display = `Today at ${formatDate(date, 'HH:mm')}`;
  } else if (isYesterday(date)) {
    display = `Yesterday at ${formatDate(date, 'HH:mm')}`;
  } else if (isThisWeek(date)) {
    display = `${formatDate(date, 'EEEE')} at ${formatDate(date, 'HH:mm')}`;
  } else {
    display = `${formatDate(date, 'MM/dd/yyyy')} at ${formatDate(date, 'HH:mm')}`;
  }

  return <span className="message-timestamp">{display}</span>;
};
